function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Swiper, defaultSwiperSettings } from '../../../src/js/swiper-utils';
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.team-block').length > 0) {
    var sliders = document.querySelectorAll('.team-block');
    sliders.forEach(function (slider) {
      var nextEl = slider.querySelector('.swiper-button-next');
      var prevEl = slider.querySelector('.swiper-button-prev');
      var navEl = slider.querySelector('.swiper-nav');
      var slideCount = slider.querySelectorAll('.swiper-slide').length;

      function updateNavVisibility() {
        if (!navEl) return;
        navEl.style.display = slideCount <= 5 && window.innerWidth >= 1536 ? 'none' : '';
      }

      updateNavVisibility();
      window.addEventListener('resize', updateNavVisibility);
      new Swiper(slider.querySelector('.swiper'), _objectSpread(_objectSpread({}, defaultSwiperSettings('auto', 330, false, false)), {}, {
        spaceBetween: 12,
        centeredSlides: false,
        slidesPerView: "auto",
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        on: {
          transitionStart: function transitionStart(swiper) {
            var max = swiper.maxTranslate();
            var movingForward = swiper.translate < swiper.previousTranslate;
            var movingBackward = swiper.translate > swiper.previousTranslate;

            if (movingForward && Math.abs(swiper.translate - max) <= 20) {
              swiper.setTranslate(max);
              swiper.updateProgress(max);
            } else if (movingBackward && Math.abs(swiper.translate - swiper.previousTranslate) <= 20) {
              var skipIndex = swiper.snapIndex - 1;

              if (skipIndex >= 0) {
                var skipTranslate = -swiper.snapGrid[skipIndex];
                swiper.setTranslate(skipTranslate);
                swiper.updateProgress(skipTranslate);
              }
            }
          },
          progress: function progress(_swiper, _progress) {
            nextEl.classList.toggle('swiper-button-disabled', _progress >= 1);
            prevEl.classList.toggle('swiper-button-disabled', _progress <= 0);
          }
        }
      }));
    });
  }
});